import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { CustomTranslationState } from './CustomTranslation.state';
import { getters } from './CustomTranslation.getters';
import { mutations } from './CustomTranslation.mutations';
import { actions } from './CustomTranslation.actions';

VueXHelper.setStoreModule(Module.CUSTOMTRANSLATION, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new CustomTranslationState(),
  getters,
  mutations,
  actions,
};
